export const defaultConfigs = {
    title: '',
    successUrl: undefined,
    buttonText: 'Save Password',
    headingSize: 'h4',
};
